import React, { useState, useEffect } from 'react';
import Cookies from 'js-cookie'
import {
  collection,
  onSnapshot,
  query,
  orderBy,
  where,
  serverTimestamp,
  addDoc,
} from 'firebase/firestore';

import './Comments.css';
import { db } from '../../Config/firebase';
import CommentItem from './CommentItem';
import { Errormsg } from '../tostifymsg/Errrormsg';
import { imgpathapp } from '../../Config/config';
import profileimg from "../../assets/large profileicon.svg";
import { ModalCustom } from '../modalcustom/modalcustom';
import { useSubscriptionAccess } from '../../shared/hooks/useSubscriptionAccess';
import { openModal } from '../../feature/showSlice/showModalSlice';
import { useDispatch } from 'react-redux';

function Comments({
  movieId,
  movieName = '',
}) {
  const dispatch = useDispatch();
  const userprofileimage = Cookies.get("userprofileimage");
  const email = Cookies.get("email");
  const userId = Cookies.get("id");
  const username = Cookies.get("username");
  const firebaseUseruid = Cookies.get('firebaseuid');

  const commentsNoticesAccess = useSubscriptionAccess("comments-notices");
  
  const [comments, setComments] = useState([]);
  const [commentsAll, setCommentsAll] = useState([]);
  const [replyContent, setReplyContent] = useState('');
  const [additionalReportContent, setAdditionalReportContent] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [selectedCommentId, setSelectedCommentId] = useState(null);
  const [reportReason, setReportReason] = useState('');

  useEffect(() => {
    if (!movieId) return;

    const q = query(
      collection(db, 'MovieComments'),
      where('movieId', '==', movieId),
      orderBy('createdAt', 'desc')
    );

    const unsubscribe = onSnapshot(q, (snapshot) => {
      const movieComments = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
      }));

      setCommentsAll(movieComments);

      const formatedComments = movieComments
        .filter(comment => typeof comment.parentCommentId === 'undefined' || !comment.parentCommentId)
        .map(comment => {
          return ({
            ...comment,
            date: comment.createdAt?.toDate().toISOString() || new Date().toISOString(),
            subComments: movieComments.sort((a, b) => a.createdAt - b.createdAt).filter(subComment => subComment.parentCommentId === comment.id)
          });
        });

      setComments(formatedComments);
    });

    return () => unsubscribe();
  }, [movieId]);

  const handleSubmitComment = async () => {
    try {
      if (!validateLoggedIn()) return;

      if (replyContent.trim() === '') {
        Errormsg('Comment content cannot be empty.');
        return;
      }

      const dateNowServer = serverTimestamp();
      let imageProfileUrl = `${imgpathapp}` + (
        typeof userprofileimage === 'undefined' || 
        userprofileimage === 'undefined' || 
        userprofileimage === null 
        ? `${profileimg}` : 
          `${userprofileimage}`);

      const replyData = {
        comment: replyContent.trim(),
        createdAt: dateNowServer,
        isAdmin: false,
        likes: [],
        movieId: movieId,
        reportsIds: [],
        updatedAt: dateNowServer,
        userEmail: email,
        userGafferId: userId,
        userId: firebaseUseruid,
        username: username,
        userProfileUrl: imageProfileUrl
      };

      await addDoc(collection(db, "MovieComments"), replyData);

      setReplyContent('');
    } catch (error) {
      console.error('❌ Error submitting comment:', error);
      Errormsg(error.message);
    }
  }

  const handlerReport = () => {
    try {
      if (!selectedCommentId) {
        throw new Error('No comment selected for reporting.');
      }

      const findComment = commentsAll.find(c => c.id === selectedCommentId) || null;      

      if(!findComment) {
        throw new Error('Selected comment not found.');
      }

      const reportComment = {
        commentId: selectedCommentId,
        createdAt: serverTimestamp(),
        isResolved: false,
        movieId: movieId,
        movieName: movieName,
        reportedComment: findComment || {},
        reportDescription: additionalReportContent.trim(),
        reportReason: reportReason,
        reporterEmail: findComment.userEmail || '',
        reporterId: findComment.userId || '',
        reporterName: findComment.username || '',
        updatedAt: serverTimestamp(),
      }

      addDoc(collection(db, "ReportMovieComments"), reportComment);

      setAdditionalReportContent('');
      setShowModal(false);
    } catch (error) {
      console.error('❌ Error submitting report:', error);
      Errormsg(error.message);
    }
  }

  const validateLoggedIn = () => {
      if (!userId) {
        dispatch(openModal());
  
        return false;
      }
  
      return true;
    }

  return (
    <>
      <div className="component-comments">
        <div className="comment-title">
          <i className="fa fa-comments" aria-hidden="true"></i>
          <h2>Comments</h2>
        </div>

        <div className="add-comment">
          <textarea 
            placeholder="Add a comment..." 
            rows="4"
            value={replyContent}
            onChange={(e) => setReplyContent(e.target.value)}
            disabled={!commentsNoticesAccess.hasAccess}
          ></textarea>

          <div className="comment-btn-group">
            <button className="clear-button" onClick={() => setReplyContent('')}>Clear</button>
            <button className={`submit-button ${!commentsNoticesAccess.hasAccess ? 'bg-disabled' : ''}`} onClick={handleSubmitComment}>Post Comment</button>
          </div>
        </div>

        <div className="comments-list">
          { comments.length === 0 && (<p className="no-comments">No comments yet. Be the first to comment!</p>) }
          
          { comments.map(comment => (
              <CommentItem 
                key={comment.id} 
                comment={comment} 
                userLoggedIn={userId || null} 
                replyToComment={true}
                uidFirebase={firebaseUseruid || null}
                handlerReportAction={(commentId) => {
                  if (!commentId) return;                

                  setSelectedCommentId(commentId);
                  setShowModal(true);
                }}
              />
            ))
          }
        </div>
      </div>

      <ModalCustom
        modalCustom={showModal}
        setModalCustom={setShowModal}
        title={`Report Comment`}
      >
        <div>
          <h5 className="modal-title font-weight-bold mt-2 mb-4 fw-bold">Reason for report</h5>

          <ul className='list-group list-unstyled ms-0 pr-0'>
            <li className='list-group-item line-style-none bg-transparent border-0 ps-1 mb-4'>
              <div className=''>
                <input type="radio" className='d-none radio-custom' onChange={(e) => setReportReason(e.target.value)} id="spam" name="reportReason" value="spam" />
                <label htmlFor="spam" className='ms-2 text-white d-flex align-items-center label-custom'>
                  <div className='custom-radio me-2'></div> Spam or misleading content
                </label>
              </div>
            </li>
            <li className='list-group-item line-style-none bg-transparent border-0 ps-1 mb-4'>
              <div className=''>
                <input type="radio" className='d-none radio-custom' onChange={(e) => setReportReason(e.target.value)} id="Inappropriate" name="reportReason" value="inappropriate" />
                <label htmlFor="Inappropriate" className='ms-2 text-white d-flex align-items-center label-custom'>
                  <div className='custom-radio me-2'></div> Inappropriate or offensive content
                </label>
              </div>
            </li>
            <li className='list-group-item line-style-none bg-transparent border-0 ps-1 mb-4'>
              <div className=''>
                <input type="radio" className='d-none radio-custom' onChange={(e) => setReportReason(e.target.value)} id="harassment" name="reportReason" value="harassment" />
                <label htmlFor="harassment" className='ms-2 text-white d-flex align-items-center label-custom'>
                  <div className='custom-radio me-2'></div> Harassment or bullying
                </label>
              </div>
            </li>
            <li className='list-group-item line-style-none bg-transparent border-0 ps-1 mb-4'>
              <div className=''>
                <input type="radio" className='d-none radio-custom' onChange={(e) => setReportReason(e.target.value)} id="false-info" name="reportReason" value="fake_news" />
                <label htmlFor="false-info" className='ms-2 text-white d-flex align-items-center label-custom'>
                  <div className='custom-radio me-2'></div> False information
                </label>
              </div>
            </li>
            <li className='list-group-item line-style-none bg-transparent border-0 ps-1 mb-4'>
              <div className=''>
                <input type="radio" className='d-none radio-custom' onChange={(e) => setReportReason(e.target.value)} id="copyright" name="reportReason" value="copyright" />
                <label htmlFor="copyright" className='ms-2 text-white d-flex align-items-center label-custom'>
                  <div className='custom-radio me-2'></div> Copyright violation
                </label>
              </div>
            </li>
            <li className='list-group-item line-style-none bg-transparent border-0 ps-1 mb-4'>
              <div className=''>
                <input type="radio" className='d-none radio-custom' onChange={(e) => setReportReason(e.target.value)} id="other" name="reportReason" value="other" />
                <label htmlFor="other" className='ms-2 text-white d-flex align-items-center label-custom'>
                  <div className='custom-radio me-2'></div> Other
                </label>
              </div>
            </li>
          </ul>

          <h5 className="modal-title font-weight-bold mt-2 mb-2 fw-bold">Additional details (optional): </h5>

          <textarea 
            placeholder="Provide more details about why you're reporting this comment..." 
            rows="4"
            className={'additional-details-textarea'}
            value={additionalReportContent}
            onChange={(e) => setAdditionalReportContent(e.target.value)}
          ></textarea>
          
          <div className="comment-btn-group mt-4 d-flex justify-content-end">
            <button className="btn text-white clear-button btn-transparent" onClick={() => {
              setAdditionalReportContent('');
              setShowModal(false);
            }}>Cancel</button>
            <button 
              className={`btn ${ additionalReportContent ? 'btn-warning' : 'btn-submit-report' }`} 
              onClick={handlerReport}
            >Submit Report</button>
          </div>
        </div>
      </ModalCustom>
    </>
  );
}

export default Comments;